import { Image } from "@/components/blocks/image/image.class";
import { School } from "@/data/classes/school.class";

export class Project {
	// identifiers
	id;
	slug;
	
	title;
	image;
	date;
	category;
	content;
	description;
	curators;
	
	constructor (object)
	{		
		// console.log("🚄 Project:", object )
		// identifiers
		this.id = object.id || null;
		this.author = object.author || null;
		this.date = object.date || null;
		this.status = object.status || null;
		this.slug = object.slug || null;
		this.title = object.title.rendered || null;
		this.titleEng = object.meta_box.project_info.title_eng || null;

		// Info
		this.course = object.meta_box.project_info.course || null;
		this.courseEng = object.meta_box.project_info.course_eng || null;
		this.class = object.meta_box.project_info.class || null;
		this.classEng = object.meta_box.project_info.class_eng || null;

		// Content
		this.professors = object.meta_box.project_content.professors || null;
		this.students = object.meta_box.project_content.students || null;
		this.objective = object.meta_box.project_content.objective || null;
		this.objectiveEng = object.meta_box.project_content.objective_eng || null;
		this.technology = object.meta_box.project_content.technology || null;
		this.technologyEng = object.meta_box.project_content.technology_eng || null;
		this.keywords = object.meta_box.project_content.keywords || [];

		// Concept
		this.concept = object.meta_box.project_concept.concept || null;
		this.conceptEng = object.meta_box.project_concept.concept_eng || null;

		if ( object.meta_box.project_concept.images && object.related_ids ) {
			this.images = object.meta_box.project_concept.images.map( image => {
				let imageContent = object.related_ids[image];
				if(imageContent)
					return new Image(object.related_ids[image])
			})
		} else {
			this.images = []
		}
		
		//Relations
		if (object.meta_box.school_to_project_from.length && object.related_ids) {
			this.schools = object.meta_box.school_to_project_from.map(school => {
				let schoolContent = new School(object.related_ids[school])
				return schoolContent;
			});
		} else {
			this.schools = []
		}
	}
}

export class ProjectApplication {

	
	title;
	meta_box;
	link;
	status;

	constructor(object) {
		this.meta_box = {
			project_info: {

			},
			project_content: {

			},
			project_concept: {

			},
			school_to_project_from: [],
		};

		this.title = object.title;
		
		// Info
		this.meta_box.project_info.title_eng = object.titleEng;
		this.meta_box.project_info.course = object.course;
		this.meta_box.project_info.course_eng = object.courseEng;
		this.meta_box.project_info.class = object.class;
		this.meta_box.project_info.class_eng = object.classEng;
		this.meta_box.project_info.date = object.date;
		
		// Content
		this.meta_box.project_content.professors = object.professors;
		this.meta_box.project_content.students = object.students;
		this.meta_box.project_content.objective = object.objective;
		this.meta_box.project_content.objective_eng = object.objectiveEng;
		this.meta_box.project_content.technology = object.technology;
		this.meta_box.project_content.technology_eng = object.technologyEng;
		this.meta_box.project_content.keywords = object.keywords;
		
		// Concept
		this.meta_box.project_concept.concept = object.concept;
		this.meta_box.project_concept.concept_eng = object.conceptEng;

		if(object.images) {
			this.meta_box.project_concept.images = object.images.map( image => {
				return image.id;
			})
		}
		
		// School
		if (object.schools) {
			this.meta_box.school_to_project_from = object.schools.map(school => {
				return school.id
			})
		}

		this.status = "publish";
	}
}



// WEBPACK FOOTER //
// ./src/data/classes/project.class.js